var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/link_footer.tsx";
const _excluded = ["children", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Text } from 'soapbox/components/ui';
import emojify from 'soapbox/features/emoji/emoji';
import { useSoapboxConfig, useOwnAccount, useTheme } from 'soapbox/hooks';
import sourceCode from 'soapbox/utils/code';

//@ts-expect-error no typedef
import manganeDark from '../../../../icons/mangane-dark.svg';
//@ts-expect-error no typedef
import mangane from '../../../../icons/mangane.svg';
const FooterLink = _ref => {
  let {
      children,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Link, _extends({
    className: classNames('text-xs text-gray-400 hover:text-gray-500 hover:underline', className)
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }), children));
};
const LinkFooter = () => {
  const account = useOwnAccount();
  const soapboxConfig = useSoapboxConfig();
  const darkMode = useTheme() === 'dark';
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "xs",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, soapboxConfig.linkFooterMessage ? /*#__PURE__*/React.createElement("span", {
    className: "inline-block align-middle",
    dangerouslySetInnerHTML: {
      __html: emojify(soapboxConfig.linkFooterMessage)
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "mt-4 gap-2 text-right",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Mangane logo",
    src: darkMode ? manganeDark : mangane,
    className: "ml-auto mb-2 w-[24px] h-[24px] opacity-90",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "getting_started.open_source_notice",
    defaultMessage: "{code_name} is open source software. You can contribute or report issues at {code_link} ({code_version}).",
    values: {
      code_name: sourceCode.displayName,
      code_link: /*#__PURE__*/React.createElement(Text, {
        theme: "subtle",
        size: "xs",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 28
        }
      }, /*#__PURE__*/React.createElement("a", {
        className: "underline",
        href: sourceCode.url,
        rel: "noopener",
        target: "_blank",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 59
        }
      }, sourceCode.repository)),
      code_version: sourceCode.version
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center justify-center divide-x-dot text-gray-400",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 7
    }
  }, account && /*#__PURE__*/React.createElement(React.Fragment, null, account.admin && /*#__PURE__*/React.createElement(FooterLink, {
    to: "/soapbox/config",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation_bar.soapbox_config",
    defaultMessage: "Mangane config",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 46
    }
  })))));
};
export default LinkFooter;